























































































































































































































import Vue from 'vue'
import Component from 'vue-class-component'
import axios from "axios";

type User = {
    id: number,
    login: string,
    password: string,
    password_hash: string,
}

type UserHistory = {
    time: string,
    document_id: string,
}

@Component
export default class Users extends Vue {
    private user: User = {} as User
    private user_dialog: Boolean = false
    private add_user_dialog: Boolean = false
    private user_logs_headers: any = [
        {
            text: "Time",
            value: "time"
        },
        {
            text: "Action",
            value: "action",
        },
        {
            text: "Target type",
            value: "target_type",
        },
        {
            text: "Target id",
            value: "target_id"
        },
        {
            text: "IP",
            value: "ip"
        }
    ]
    private user_logs: any = []
    private users: any = {
        headers: [
            {
                text: "Login",
                value: "login",
            },
            {
                text: "Actions",
                value: "action",
                sortable: false,
                align: 'end'
            },
        ],
        items: [] as Array<User>,
    }

    mounted() {
        this.$store.dispatch('set_title', 'Users')
        this.sync_users()
    }

    private sync_users() {
        axios
            .get<Array<User>>(
                '/api/v1/users')
            .then(response => {
                this.users.items = response.data
            })
    }


    show_user(user: User) {
        this.user_logs = []
        this.user = user
        this.user_dialog = true

        axios
            .get<any>(
                '/api/v1/users/'.concat(user.id.toString(), '/logs'),
            )
            .then((resp) => {
                this.user_logs = resp.data
            })
    }

    delete_user(user: User) {
        axios
            .delete<any>(
                '/api/v1/users/'.concat(user.id.toString()),
            )
            .then(() => {
                const index = this.users.items.indexOf(user);
                if (index > -1) {
                    this.users.items.splice(index, 1);
                }
            })
    }

    addPermission() {
        this.user_permission_dialog = true
    }

    private name: string = ''
    private surname: string = ''
    private email: string = ''
    private active: boolean = true
    private login: string = ''
    private password: string = ''
    private role: string = 'manager'

    private permission = {
        permission: '',
        target_id: '',
        target_type: '',
    }
    private user_permission_dialog = false

    add_permission() {
        this.user_permissions.push(this.permission)
        this.user_permission_dialog = false
    }

    private user_permission_headers = [
        {
            text: "Permission",
            value: "permission",
        },
        {
            text: "Target type",
            value: "target_type",
        },
        {
            text: "Target ID",
            value: "target_id",
        }
    ]

    private user_permissions: Array<any> = []

    erase_user_info() {
        this.name = ''
        this.surname = ''
        this.email = ''
        this.active = true
        this.login = ''
        this.password = ''
        this.role = 'manager'
    }

    add_user() {
        let user = {
            name: this.name,
            login: this.login,
            password: this.password,
            role: this.role,
            surname: this.surname,
            email: this.email,
            active: this.active,
            permissions: this.user_permissions,
        }
        axios
            .post<User, any>(
                '/api/v1/users',
                user
            )
            .then(() => {
                this.add_user_dialog = false
                this.users.items.push(user)
                this.erase_user_info()
            })
    }

    navigate_document(document_id: number) {
        this.$router.push({
            name: 'Document',
            params: {
                id: String(document_id),
            }
        })
    }
}
